import React from 'react';

import Wait from '@react/react-spectrum/Wait';
import StatusLight from '@react/react-spectrum/StatusLight';

export default function SandboxStatus({ loading, error, data }) {
  if (loading) {
    return (
      <>
        <Wait size="S" /> <span>Checking sandbox status</span>
      </>
    );
  } else if (error) {
    return <HandleResourceError error={error} />;
  } else if (data) {
    switch (data?.aep?.details?.state) {
      case 'active':
        return <StatusLight variant="positive">Active</StatusLight>;
      case 'resetting':
        return <StatusLight variant="notice">Resetting</StatusLight>;
    }
  } else {
    return <div></div>;
  }
}

function HandleResourceError(error) {
  const code = error?.error?.response?.data?.errorStatus;
  const message = error?.error?.response?.data?.message;

  switch (code) {
    case 400:
      return <span> {error.error.response.data.message}</span>;
    case 403:
      return (
        <span>
          `Unauthorized. Possible cause: Your sandbox is not added to the
          product profile with access to DSN Adobe I/O integration. Please
          update your profile and try again`
        </span>
      );
    case 404:
      return (
        <>
          <StatusLight variant="negative">Sandbox doesn't exist</StatusLight>
        </>
      );
    default:
      return <span>An error occured: {error.error.message}</span>;
  }
}
